// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"f9cc61dc","166":"cc814f7a"}[chunkId] + ".chunk.css";
};